exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-item[data-v-3299cbc3]{\n  max-width: 300px;\n}\n.upload-wrap[data-v-3299cbc3]{\n  width: 200px;\n  height: 200px;\n  border: 1px dashed #e8e8e8;\n}\n.footer-spl[data-v-3299cbc3]{\n  border-top: 1px solid #e8e8e8;\n  margin: 10px 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3299cbc3","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/BaseForm/index.vue
// module id = fpK4
// module chunks = 142